import { Component } from "react";
import { useLocation } from "react-router-dom";

/* Fängt Render-/Commit-Fehler einer Route ab, damit ein einzelner Fehler nie die ganze
   Seite einfriert. Reset bei Routenwechsel über resetKey (Pathname), damit der Nutzer
   durch Weg-/Zurücknavigieren wieder herauskommt. */
class Boundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidUpdate(prev) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-[60vh] flex flex-col items-center justify-center gap-5 px-6 text-center" role="alert" data-testid="route-error-boundary">
          <img src="/img/mascots/robbie-winkt.webp" alt="" width="96" height="96" className="h-24 w-24 object-contain" />
          <h1 className="text-2xl font-extrabold text-[#111]">Da ist etwas schiefgelaufen</h1>
          <p className="max-w-md text-sm text-[#4A4A4A]">Bitte lade die Seite neu. Wenn es erneut auftritt, melde dich gern bei uns.</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="inline-flex items-center justify-center rounded-full bg-[#111] text-white px-7 py-3 text-sm font-bold uppercase tracking-[0.15em] hover:bg-[#333] transition-colors"
            data-testid="route-error-reload"
          >
            Seite neu laden
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export const RouteErrorBoundary = ({ children }) => {
  const { pathname } = useLocation();
  return <Boundary resetKey={pathname}>{children}</Boundary>;
};

export default RouteErrorBoundary;
